module.exports = __webpack_public_path__ + "img/xb.f1ca8653.jpg";